<mat-progress-bar
  [mode]="mode"
  [value]="progress"
  [class.hidden]="hidden"
  [style.--transition-duration]="transitionDuration + 'ms'"
  aria-label="Navigation progress bar."
></mat-progress-bar>
